import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders } from '@angular/core';
import { NoticeComponent } from './notice/notice.component';
import { WaitComponent } from './wait/wait.component';
import { InfoService } from '../info/info.service';
import { SharedModule } from '@app/shared/modules/shared.module';
import { ConfirmComponent } from '@app/core/info/confirm/confirm.component';
import { QrModule } from './qr/qr.module';
import { QrComponent } from '@app/core/info/qr/qr.component';

@NgModule({
    imports: [CommonModule, SharedModule, QrModule],
    entryComponents: [ConfirmComponent, QrComponent],
    declarations: [NoticeComponent, WaitComponent, ConfirmComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [NoticeComponent, WaitComponent, ConfirmComponent],
    providers: [InfoService]
})
export class InfoModule {
    static forRoot(): ModuleWithProviders<InfoModule> {
        return {
            ngModule: InfoModule,
            providers: [InfoService]
        };
    }
}
